import { useMutation } from '@lumapps/base-api/react-query';
import { deauthorizeConnector } from '@lumapps/connectors/api/connectorsApi';

/**
 * Mutation hook to deauthorize a connector.
 */
export const useDeauthorizeConnector = () =>
    useMutation({
        mutationFn: async (connectorId: string) => {
            const { data } = await deauthorizeConnector(connectorId);
            return data;
        },
    });
